import type { IntlShape } from 'react-intl'
import { getMaxGuestCount } from 'lib/offer/occupancyUtils'

export function getVillaCapacityText(intl: IntlShape, offer: App.VillaOffer | App.VillaOfferSummary) {
  if (!offer.lowestPricePackage) return ''

  const roomRate = offer.lowestPricePackage.roomRate
  if (!roomRate) {
    return ''
  }

  const roomType = offer.lowestPricePackage.roomType
  if (!roomType) {
    return ''
  }

  const capacity = getMaxGuestCount(roomRate.capacities)
  if (!capacity) return ''

  const hasBedrooms = !!roomType.numberOfBedrooms
  const hasBathrooms = !!roomType.numberOfBathrooms

  if (hasBedrooms && hasBathrooms) {
    // eslint-disable-next-line formatjs/no-multiple-plurals
    return intl.formatMessage(
      {
        id: 'EUp8iR3Cwca0ivofLguN',
        defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}} · {bedroomCount, plural, one {# bedroom} other {# bedrooms}} · {bathroomCount, plural, one {# bathroom} other {# bathrooms}}',
        description: 'Villa capacity summary with guests, bedrooms, and bathrooms',
      },
      { guestCount: capacity, bedroomCount: roomType.numberOfBedrooms, bathroomCount: roomType.numberOfBathrooms },
    )
  }

  if (hasBedrooms) {
    // eslint-disable-next-line formatjs/no-multiple-plurals
    return intl.formatMessage(
      {
        id: 'T__IG1aJMvOh4U_8EfGy',
        defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}} · {bedroomCount, plural, one {# bedroom} other {# bedrooms}}',
        description: 'Villa capacity summary with guests and bedrooms in the villas section',
      },
      { guestCount: capacity, bedroomCount: roomType.numberOfBedrooms },
    )
  }

  if (hasBathrooms) {
    // eslint-disable-next-line formatjs/no-multiple-plurals
    return intl.formatMessage(
      {
        id: 'AqoHcQdC2mAmS809YrGA',
        defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}} · {bathroomCount, plural, one {# bathroom} other {# bathrooms}}',
        description: 'Villa capacity summary with guests and bathrooms in the villas section',
      },
      { guestCount: capacity, bathroomCount: roomType.numberOfBathrooms },
    )
  }

  return intl.formatMessage(
    {
      id: '-RmGt1ZBw6xjkRPBABca',
      defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}}',
      description: 'Villa capacity summary with guests only on the villa or rental property page',
    },
    { guestCount: capacity },
  )
}
